import React, { useState, useEffect, useContext } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Stack, Divider, TextField } from '@mui/material'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { styled } from '@mui/material/styles'
import { Link, useLocation } from 'react-router-dom'
import GroupManage from './GroupManage'
import OTA from './OTA'
import { MantineReactTable } from 'mantine-react-table'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AddSharpIcon from '@mui/icons-material/AddSharp'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Paper from '@mui/material/Paper'
import Draggable from 'react-draggable'
import Checkbox from '@mui/material/Checkbox'
import Api from '../../../Api/Api'
import { TreeSelect } from 'antd'

import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import secureLocalStorage from 'react-secure-storage'
import ExportToExcel from '../../../Components/ExportToExcel'
import { DataContext } from '../../../Context/LocDataContext'
import plus_icon from '../../../asset/plus_icon.png'

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>
}

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  grid2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 35,
    background: '#D9D9D9',
    borderRadius: '3px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#000000',
    fontFamily: 'Noto Sans KR',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '15.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    display: 'flex',
    justifyContent: 'flex-start',
    justifyItems: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  Typography4: {
    color: '#ffffff',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  Typography5: {
    marginLeft: 1,
    marginTop: 1,
    marginBottom: 1,
    fontSize: 14,
    color: '#d1d1d1',
  },
  Box1: {
    color: '#ffffff',
    width: 200,
    minHeight: '30px',
    height: 'fit-content',
    border: '1px solid',
    borderRadius: '5.53px',
    wordWrap: 'break-word',
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  TableCellHeader1: {
    background: '#D9D9D9',
    color: '#022022',
    borderBottom: '1px solid #CCCCCC',
  },
}

const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',

  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderBottom: '7px solid',
    // border색깔 시작
    borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
    borderImageSlice: 1,
    // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))

//tab in tab
const StyledTabInTab = styled(Tab)(({ theme }) => ({
  color: '#807F88',
  fontFamily: 'Noto Sans KR',
  fontSize: '12px',
  height: 30,
  fontWeight: 500,
  lineHeight: '28.96px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',
  borderRadius: '10px 10px 0px 0px',
  borderTop: '0.1px solid #454546',
  borderRight: '0.1px solid #454546',
  borderLeft: '0.1px solid #454546',
  background: '#AFAFAF',
  '&.Mui-selected': {
    fontWeight: 700,
    color: '#FFFFFF',
    borderRadius: '10px 10px 0px 0px',
    background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
    // borderBottom: '7px solid',
    // // border색깔 시작
    // borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
    // borderImageSlice: 1,
    // // border색깔 끝
  },
  '&:hover': {
    fontWeight: 700,
    color: '#FFFFFF',
  },
}))

export default function DeviceManage() {
  const loginId = secureLocalStorage.getItem('loginId')
  const [regDeviceData, setRegDeviceData] = useState({
    di: null,
    dsi: null,
    dname: null,
    loid: null,
    topic_list: [],
    ble_rssi: null,
    b_service_list: [],
  })
  const [regDslData, setRegDslData] = useState({
    dsi: '',
    orgid: '',
    dsname: '',
    cnm: '',
    options: {
      topic_list: [''],
      ble_rssi: 0,
      b_service_list: [''],
    },
  })
  const { inputOrgid, inputLoid, setInputOrgid, setInputLoid } = useContext(DataContext)
  const [OrgData, setOrgData] = useState([])
  const [OrgName, setOrgName] = useState('')
  const [newInputType, setNewInputType] = useState('')
  const [newInputCmn, setNewInputCmn] = useState('')
  const [newInputOption, setNewInputOption] = useState({})

  // const [inputOrgid, setInputOrgid] = useState('1110')
  // const [inputLoid, setInputLoid] = useState('1110')
  const [inputDi, setInputDi] = useState('')
  const [inputDname, setInputDname] = useState('')
  const [inputDsi, setInputDsi] = useState('')
  const [deviceList, setDeviceList] = useState([])
  const [openDialog, setOpenDialog] = React.useState(false)
  const [value, setValue] = React.useState('1')
  const location = useLocation()
  const [valueTab, setValueTab] = React.useState('/User/IoTManage/DeviceManage')
  const [valueTab2, setValueTab2] = React.useState('false')
  const [checkValue, setCheckValue] = React.useState(false)
  // const [inputLoid, setInputLoid] = React.useState(inputLoid)
  const [inputLocation, setInputLocation] = React.useState('')
  const [locationList, setLocationList] = React.useState([])
  const [dslList, setDslList] = React.useState([])
  const [rowSelection, setRowSelection] = React.useState({})
  const [modifyDname, setModifyDname] = React.useState('')
  const [modifyDloc, setModifyDloc] = React.useState('')
  const [regFlag, setRegFlag] = React.useState(false)
  // console.log('inputLoid:', inputLoid)
  // console.log('inputLoid:', inputLoid)
  // console.log('inputOrgid:', inputOrgid)
  //초기화면 진입시 최상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  React.useEffect(() => {
    if (inputOrgid === undefined && inputOrgid === null && inputOrgid === '') {
      setInputOrgid('1110')
    }
    if (inputLoid === undefined && inputLoid === null && inputLoid === '') {
      setInputLoid('62d26fb0')
    }
  }, [])

  React.useEffect(() => {
    console.log('useEffect location.pathname:', location.pathname.toString())
    setValueTab(location.pathname.toString())
  }, [location.pathname])

  React.useEffect(() => {
    // getLocationList()
    getDeviceListckNet()
    Org()
  }, [])

  React.useEffect(() => {
    getDeviceListloid()
    getDslListorgid()
  }, [valueTab2])

  React.useEffect(() => {
    setLocationList([])
    getLocationList()
    getDeviceListorgid()
    getOrgName()
  }, [inputOrgid])

  useEffect(() => {
    getDeviceListloid()
  }, [inputLoid])

  React.useEffect(() => {
    //do something when the row selection changes...
    console.log('rowSelection:', rowSelection)

    let arr = Object.keys(rowSelection)
    console.log('arr:', arr)
    console.info({ rowSelection })
  }, [rowSelection])

  const handleDsl = (event) => {
    const values = event.target.value
    let copyState = { ...regDeviceData }
    copyState.cnm = values.cnm
    copyState.dsi = values.dsi
    copyState.topic_list = values.options.topic_list
    copyState.ble_rssi = values.options.ble_rssi
    copyState.b_service_list = values.options.b_service_list

    console.log('handleDsl values:', values)
    console.log('handleDsl copyState:', copyState)
    setInputDsi(values)
    setRegDeviceData(copyState)
  }
  const handleNewInputType = (e) => {
    const values = e.target.value.replace(/\s+/g, '')
    setNewInputType(values)
    const result = findTextFromType(values)
    console.log('handleNewInputType result:', result)
    return result
  }

  const handleModifyDname = (e, param) => {
    const values = e.target.value.replace(/\s+/g, '')
    console.log('handleModifyDname values:', values)
    console.log('handleModifyDname param:', param)
    setModifyDname(values)
    let copyList = [...deviceList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.di === param.di
    })
    copyList[find1].dname = values
    setDeviceList(copyList)
  }

  const handleModifyDloc = (e, param) => {
    const values = e.target.value
    console.log('handleModifyDloc values:', values)
    console.log('handleModifyDloc param:', param)
    setModifyDloc(values)
    let copyList = [...deviceList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.di === param.di
    })
    copyList[find1].loid = values
    setDeviceList(copyList)
  }

  //신규장비유형 이름입력 변환 후 옵션값 적용
  function findTextFromType(param) {
    const toLowerCase = param.toLowerCase().replace(/\s+/g, '')
    const Gateway = {
      topic_list: ['tts', 'Status', 'Update'],
      ble_rssi: 75,
      b_service_list: null,
    }
    const Repeater = {
      topic_list: ['tts', 'Status'],
      ble_rssi: 75,
      b_service_list: null,
    }
    const Speaker = {
      topic_list: ['Speaker'],
      ble_rssi: null,
      b_service_list: null,
    }
    const Other = {
      topic_list: ['Data', 'Alarm'],
      ble_rssi: null,
      b_service_list: ['91bad492-b950-4226-aa2a-000000000001'],
    }
    const caseList = ['gateway', 'repeater', 'speaker']

    let resutl_param2 = ''
    const resutl_param1 = caseList.map((item) => {
      const regexr = new RegExp(`${item}`, 'g')
      // console.log('regexr:', regexr)
      const result_match = toLowerCase.match(regexr)
      if (result_match !== null && result_match !== undefined) {
        resutl_param2 = result_match[0]
      }
    })

    // console.log('findTextFromType resutl_param2:', resutl_param2)

    switch (resutl_param2) {
      case 'gateway':
        if (valueTab2 === 'true') {
          return setNewInputOption(Gateway)
        } else {
          setNewInputType('')
          setNewInputOption({})
          return alert('네트워크 장비 유형입니다.네트워크 탭 선택 후 장비등록 해주세요.')
        }

      case 'repeater':
        if (valueTab2 === 'true') {
          return setNewInputOption(Repeater)
        } else {
          setNewInputType('')
          setNewInputOption({})
          return alert('네트워크 장비 유형입니다.네트워크 탭 선택 후 장비등록 해주세요.')
        }
      case 'speaker':
        if (valueTab2 === 'false') {
          return setNewInputOption(Speaker)
        } else {
          setNewInputType('')
          setNewInputOption({})
          return alert('안전 장비 유형입니다.안전장비 탭 선택 후 장비등록 해주세요.')
        }
      default:
        if (valueTab2 === 'false') {
          return setNewInputOption(Other)
        } else {
          return setNewInputOption({})
        }
    }
  }

  //유효성검사
  const validation = (param) => {
    let check = /[~!@#$%^&*()+|<>?:{}.,/;='"ㄱ-ㅎ | ㅏ-ㅣ |가-힣]/
    return check.test(param)
  }

  const handleNewInputCmn = (e) => {
    const values = e.target.value.replace(/\s+/g, '')
    setNewInputCmn(values)
    // console.log('handleNewInputCmn values:', values)
  }

  const handleinputLoid = (event) => {
    setInputLoid(event.target.value)
  }

  const handleInputLocation = (event) => {
    const values = event.target.value
    let copyState = { ...regDeviceData }
    copyState.loid = values
    console.log('handleInputLocation copyState:', copyState)
    setRegDeviceData(copyState)
    setInputLocation(values)
  }

  const handleInputDi = (event) => {
    if (validation(event.target.value)) {
      alert('한글이나 특수문자는 입력 할 수 없습니다.')
    }
    const values = event.target.value.replace(/\s+/g, '')
    const result = values.replace(/[^A-Za-z0-9_]/gi, '')
    let copyState = { ...regDeviceData }
    copyState.di = result
    setInputDi(result)
    setRegDeviceData(copyState)
  }

  const handleInputDname = (event) => {
    const values = event.target.value.replace(/\s+/g, '')
    let copyState = { ...regDeviceData }
    copyState.dname = values
    setInputDname(values)
    setRegDeviceData(copyState)
  }

  const handleCheckChange = (event) => {
    console.log('handleCheckChange:', event.target.checked)
    setCheckValue(event.target.checked)
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const handleChange2 = (event, newValue) => {
    setValueTab2(newValue)
  }
  const handleClickOpen = () => {
    if (inputOrgid === null || inputOrgid === undefined || inputOrgid === '') {
      alert('부서가 선택되지 않았습니다.')
    } else if (locationList.length <= 0) {
      alert('선택한 부서에 등록된 시설이 없습니다. 시설등록후 장비등록을 해주세요.')
    } else {
      setOpenDialog(true)
    }
  }
  const handleClickClose = () => {
    setRegFlag(false)
    setCheckValue(false)
    setNewInputCmn('')
    setNewInputOption({})
    setNewInputType('')
    setInputLocation('')
    setInputDname('')
    setInputDi('')
    setInputDsi('')
    setRegDeviceData({})
    setOpenDialog(false)
  }

  let tempList = []

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'dsi',
        header: '장비유형',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'dname',
        header: '장비명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'orglist',
        header: '지정위치',
        Cell: ({ cell }) => {
          // console.log('지정위치 typeof(cell.getValue())', typeof cell.getValue())
          // console.log('지정위치 cell.getValue()', cell.getValue())

          if (cell.getValue() !== undefined && cell.getValue() !== null && cell.getValue() !== '') {
            return cell
              .getValue()
              ?.map((item, index) => (cell.getValue().length - 1 === index ? `${item}` : `${item}> `))
          }
        },
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'topic_list',
        header: '기능갯수',
        Cell: ({ cell }) => {
          // console.log('기능갯수 typeof(cell.getValue())', typeof cell.getValue())
          // console.log('기능갯수 cell.getValue()', cell.getValue())
          if (cell.getValue() !== undefined && cell.getValue() !== null && cell.getValue() !== '') {
            return cell.getValue().length
          }
        },
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )
  // /api/v1/dsl/?ckNetDevice=true&orgid=1110'
  const getDeviceListckNet = async () => {
    // setInputOrgid("");
    // setInputLoid("");
    getDslListckNet()
    try {
      const response = await Api.get(`api/v1/devices/?ckNetDevice=${valueTab2}`)
      if (response.status === 200) {
        setDeviceList(response.data)
      }
      // console.log('getDeviceListckNet response.data:', response.data)
    } catch (e) {
      console.log('getDeviceListckNet exception', e)
    }
  }

  const getDslListckNet = async () => {
    try {
      const response = await Api.get(`api/v1/dsl/?ckNetDevice=${valueTab2}`)
      if (response.status === 200) {
        setDslList(response.data)
      }
      console.log('getDslListckNet response.data:', response.data)
    } catch (e) {
      console.log('getDslListckNet exception', e)
    }
  }

  const getDeviceListorgid = async () => {
    getDslListorgid()
    try {
      const response = await Api.get(`api/v1/devices/?ckNetDevice=${valueTab2}&orgid=${inputOrgid}`)
      if (response.status === 200) {
        setDeviceList(response.data)
      }
      console.log('getDeviceListorgid response.data:', response.data)
    } catch (e) {
      console.log('getDeviceListorgid exception', e)
    }
  }

  const getDslListorgid = async () => {
    try {
      const response = await Api.get(`api/v1/dsl/?ckNetDevice=${valueTab2}&orgid=${inputOrgid}`)
      if (response.status === 200) {
        setDslList(response.data)
      }
      console.log('getDslListorgid response.data:', response.data)
    } catch (e) {
      console.log('getDslListorgid exception', e)
    }
  }

  const getDeviceListloid = async () => {
    console.log(`ckNetDevice=${valueTab2}&orgid=${inputOrgid}&loid=${inputLoid}`)
    try {
      const response = await Api.get(`api/v1/devices/?ckNetDevice=${valueTab2}&orgid=${inputOrgid}&loid=${inputLoid}`)
      if (response.status === 200) {
        setDeviceList(response.data)
      }
      console.log('getDeviceListloid response.data:', response.data)
    } catch (e) {
      console.log('getDeviceListloid exception', e)
    }
  }

  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('Org exception', e)
    }
  }

  const getOrgName = async () => {
    try {
      const response = await Api.get(`/api/v1/orgn/${inputOrgid}`)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        console.log('getOrgName response.data', response.data)
        if (response.data.orgid === inputOrgid) {
          setOrgName(response.data.orgn)
        }
      }
      // console.log('getOrgName response.data', response.data)
    } catch (e) {
      console.log('getOrgName exception', e)
    }
  }

  const getLocationList = async () => {
    const headers = {
      istree: true,
    }
    try {
      const response = await Api.get(`/api/v1/loca/get_loca/without_bf?orgid=${inputOrgid}`)

      if (response.status === 200) {
        console.log('getLocationList:', response.data)
        setLocationList(response.data)
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      console.log('getLocationList exception', e)
    }
  }

  const postDevice = async () => {
    if (checkValue === true) {
      setRegFlag(true)
      const newDslObject = {
        dsi: newInputType,
        cnm: newInputCmn,
        orgid: inputOrgid,
        dsname: newInputType,
        options: newInputOption,
        uid: loginId,
      }
      if (
        newDslObject.options.topic_list !== undefined &&
        newDslObject.dsi !== undefined &&
        newDslObject.dsi !== null &&
        newDslObject.dsi !== '' &&
        newDslObject.orgid !== ''
      ) {
        const newDeviceObject = {
          di: inputDi,
          dsi: newDslObject.dsi,
          dname: inputDname,
          loid: inputLocation,
          topic_list: newDslObject.options.topic_list,
          ble_rssi: newDslObject.options.ble_rssi,
          b_service_list: newDslObject.options.b_service_list,
          uid: loginId,
        }
        console.log('newDslObject good:', newDslObject)
        try {
          const response = await Api.post(`api/v1/dsl`, newDslObject)

          if (response.status === 200) {
            console.log('newType register ok')
            if (
              newDeviceObject.di === null ||
              newDeviceObject.di === undefined ||
              newDeviceObject.di === '' ||
              newDeviceObject.dsi === null ||
              newDeviceObject.dsi === undefined ||
              newDeviceObject.dsi === '' ||
              newDeviceObject.dname === null ||
              newDeviceObject.dname === undefined ||
              newDeviceObject.dname === '' ||
              newDeviceObject.loid === null ||
              newDeviceObject.loid === undefined ||
              newDeviceObject.loid === ''
            ) {
              deleteDsl(newInputType)
              alert('빈칸이 있습니다')
              setRegFlag(false)
            } else {
              try {
                const response = await Api.post(`/api/v1/devices`, newDeviceObject)
                if (response.status === 200) {
                  setRegFlag(false)
                  alert('새로운 장비 유형과 장비가 등록 되었습니다')
                  setCheckValue(false)
                  setInputDname('')
                  setInputDi('')
                  setInputDsi('')
                  setNewInputType('')
                  setNewInputCmn('')
                  setNewInputType('')
                  setNewInputOption({})
                  getDeviceListorgid()
                  getDeviceListloid()
                  handleClickClose()
                } else {
                  setRegFlag(false)
                  // deleteDsl(newInputType)
                  alert('장비가 등록되지 않았습니다.')
                }
                // console.log('response.data Users', response.data)
              } catch (e) {
                setRegFlag(false)
                // deleteDsl(newInputType)
                alert(`postDevice error 1:${e.message}`)
                console.log('postDevice1 exception', e)
              }
            }
          } else {
            setRegFlag(false)
            alert('장비가 등록되지 않았습니다.')
          }
          // console.log('response.data Users', response.data)
        } catch (e) {
          setRegFlag(false)
          // deleteDsl(newInputType)
          alert(`이미등록된 장비유형 이거나 잘못된 요청입니다.postDevice 2:${e.message}`)
          console.log('postDevice2 exception', e)
        }
        console.log('postDevice newDeviceObject:', newDeviceObject)
      } else {
        setRegFlag(false)
        alert(
          '입력한 장비유형이 안정장비 유형이거나 장비유형 입력값이 없습니다.안전장비 탭을 선택하거나 올바른 장비유형을 입력하세요.'
        )
      }
    } else {
      setRegFlag(true)
      console.log('postDevice regDeviceData:', regDeviceData)
      if (
        regDeviceData.di === null ||
        regDeviceData.di === undefined ||
        regDeviceData.di === '' ||
        regDeviceData.dsi === null ||
        regDeviceData.dsi === undefined ||
        regDeviceData.dsi === '' ||
        regDeviceData.dname === null ||
        regDeviceData.dname === undefined ||
        regDeviceData.dname === '' ||
        regDeviceData.loid === null ||
        regDeviceData.loid === undefined ||
        regDeviceData.loid === ''
      ) {
        setRegFlag(false)
        alert('빈칸이 있습니다')
      } else {
        try {
          let copyData = regDeviceData
          copyData.uid = loginId
          // console.log('장비등록 copyData:', copyData)
          const response = await Api.post(`/api/v1/devices`, copyData)
          if (response.status === 200) {
            alert('장비가 등록 되었습니다')
            setInputDname('')
            setInputDi('')
            setInputDsi('')
            getDeviceListorgid()
            getDeviceListloid()
            setRegDeviceData({})
            handleClickClose()
            setRegFlag(false)
          } else {
            setRegFlag(false)
            alert('장비가 등록되지 않았습니다.')
          }
          // console.log('response.data Users', response.data)
        } catch (e) {
          setRegFlag(false)
          alert(`장비ID가 중복되었거나 잘못된 요청입니다. postDevice 3:${e.message}`)
          console.log('postDevice3 exception', e)
        }
      }
    }
  }

  //새로운 유형 장비등록 실패했을때 등록된 유형 삭제
  const deleteDsl = async (param) => {
    const tempObject = { data: { uid: loginId } }
    try {
      const response = await Api.delete(`/api/v1/dsl/${param}`, tempObject)

      if (response.status === 200) {
        console.log('deleteDsl ok response.data', response.data)
      }
    } catch (e) {
      console.log('deleteDsl exception', e)
    }
  }

  const deleteDevice = async () => {
    let arr = Object.keys(rowSelection)
    if (arr.length > 0) {
      arr.map(async (item) => {
        const tempObject = { data: { uid: loginId } }
        console.log('deleteDevice tempObject:', tempObject)
        console.log('deleteDevice item:', item)

        try {
          const response = await Api.delete(`api/v1/devices/${item}`, tempObject)
          // const response = await Api.get('/api/v1/orgn', {
          //   withCredentials: true,
          // })
          if (response.status === 200) {
            console.log('deleteDevice OK , item:', item)
            // getDeviceListorgid()
            // getDeviceListloid()
            alert('장비가 삭제 되었습니다.')
          }
          console.log('deleteDevice response.data:', response.data)
        } catch (e) {
          // getDeviceListorgid()
          // getDeviceListloid()
          alert(`장비 ${item} 가 삭제 되지 않았습니다.${e}`)
          console.log('deleteDevice exception', e)
        } finally {
          getDeviceListloid()
        }
      })

      // getDeviceListorgid()
    }
    setRowSelection({})
  }

  //기능추가 추가 항목 input
  const [moreAdd, setMoreAdd] = useState([''])

  const handleMoreAddChange = (index, value) => {
    setMoreAdd((prev) => {
      const updatedMoreAdd = [...prev]
      updatedMoreAdd[index] = value

      if (index === updatedMoreAdd.length - 1 && value.trim() !== '') {
        updatedMoreAdd.push('')

        return updatedMoreAdd
      }

      if (index !== updatedMoreAdd.length - 1 && value.trim() === '') {
        updatedMoreAdd.splice(index, 1)

        console.log(updatedMoreAdd)

        return updatedMoreAdd
      }
      const testArr = [...newInputOption.topic_list, ...updatedMoreAdd]
      console.log('testArr in handleMoreAddChange:', testArr)

      return updatedMoreAdd
    })
  }

  const modifyFlag = (param) => {
    if (inputOrgid !== undefined && inputOrgid !== null && inputOrgid !== '') {
      let copyList = [...deviceList]
      const find1 = copyList.findIndex((element, index, array) => {
        return element.di === param.di
      })
      copyList[find1].isFlag = true

      setDeviceList(copyList)
      console.log('modifyFlag deviceList:', deviceList)
    } else {
      alert('부서가 선택되지 않았습니다.')
    }
  }

  const modifyFlagSave = async (param) => {
    try {
      // const tempObject = {data:{ "uid": loginId }}
      const saveObject = { dname: param.dname, loid: param.loid, uid: loginId }
      const response = await Api.patch(`/api/v1/devices/${param.di}`, saveObject)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        alert('장비 정보가 수정되었습니다.')
      }
      // console.log('response.data', response.data)
    } catch (e) {
      alert(`장비 정보가 수정되지 않았습니다.${e}`)
      console.log('modifyFlagSave exception', e)
    }
    console.log('modifyFlagSave param:', param)
    modifyFlagCancel(param)
  }

  const modifyFlagCancel = (param) => {
    setModifyDloc('')
    setModifyDname('')
    getDeviceListloid()
    let copyList = [...deviceList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.di === param.di
    })
    copyList[find1].isFlag = false
    setDeviceList(copyList)
  }

  return (
    <div style={{ padding: 30 }}>
      <Grid container>
        <Grid
          size={12}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginLeft: 3,
            marginBottom: 1,
          }}
        >
          <TreeSelect
            className="treeSelect"
            suffixIcon={<ArrowDropDownIcon />}
            style={{ marginTop: -22 }}
            value={inputOrgid}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={OrgData}
            treeTitleRender={(item) => {
              return <Title title={item.orgn} />
            }}
            fieldNames={{ labal: 'orgid', key: 'orgid', value: 'orgid' }}
            placeholder="부서 선택"
            treeDefaultExpandAll
            onChange={(e) => {
              setInputLoid('')
              setInputOrgid(e)
            }}
          />
          {/* 시설선택 */}
          <Select value={inputLoid} onChange={handleinputLoid} sx={[styles1.Select1, { width: 150, marginLeft: 1 }]}>
            {locationList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.loid}>
                  {item.lon}
                </MenuItem>
              )
            })}
          </Select>
        </Grid>
        <Grid size={12}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={valueTab.toString()}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  sx={{ marginLeft: 3 }}
                  TabIndicatorProps={{
                    style: {
                      display: 'none',
                    },
                  }}
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <StyledTab
                    label="장비관리"
                    component={Link}
                    to="/User/IoTManage/DeviceManage"
                    value="/User/IoTManage/DeviceManage"
                  />
                  <StyledTab
                    label="그룹관리"
                    component={Link}
                    to="/User/IoTManage/GroupManage"
                    value="/User/IoTManage/GroupManage"
                  />
                  <StyledTab label="OTA" component={Link} to="/User/IoTManage/OTA" value="/User/IoTManage/OTA" />
                </TabList>
              </Box>
              <TabPanel value="/User/IoTManage/DeviceManage">
                {' '}
                <Grid container>
                  <Grid size={12} sx={styles1.grid1}>
                    <Box>
                      <Grid container sx={{ marginBottom: 2 }}>
                        <Grid
                          size={6}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                          }}
                        >
                          <Typography sx={styles1.Typography1}>장비목록</Typography>
                        </Grid>
                        <Grid
                          size={6}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            paddingRight: 3,
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              color: '#ffffff',
                              background: '#454546',
                              marginRight: 3,
                            }}
                            onClick={handleClickOpen}
                          >
                            {/* <AddSharpIcon /> */}
                            <img src={plus_icon} style={{ width: 25, height: 25, marginRight: 7 }}></img>
                            장비 등록
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                              color: '#ffffff',
                              background: '#454546',
                              marginRight: 3,
                            }}
                            onClick={() => deleteDevice()}
                          >
                            <DeleteOutlineIcon />
                            선택 삭제
                          </Button>
                          <ExportToExcel
                            data={deviceList}
                            fileName={valueTab2 === 'false' ? `안전장비목록` : '네트워크장비목록'}
                          />
                        </Grid>
                      </Grid>
                      <TabContext value={valueTab2.toString()}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <TabList
                            sx={{ marginLeft: 3 }}
                            TabIndicatorProps={{
                              style: {
                                display: 'none',
                              },
                            }}
                            onChange={handleChange2}
                            aria-label="lab API tabs example"
                          >
                            <StyledTabInTab label="안전장비" value="false" />
                            <StyledTabInTab label="네트워크장비" value="true" />
                          </TabList>
                        </Box>
                        {/* 안전장비 */}
                        <TabPanel value="false">
                          <div style={{ marginTop: -25 }}>
                            <MantineReactTable
                              initialState={{
                                pagination: {
                                  pageIndex: 0,
                                  pageSize: 30,
                                },
                              }}
                              getRowId={(row) => row.di}
                              onRowSelectionChange={setRowSelection}
                              state={{ rowSelection }}
                              selectDisplayMode="checkbox"
                              enableRowSelection={true}
                              enableMultiRowSelection={true}
                              enableColumnActions={false}
                              enableColumnFilters={false}
                              enablePagination={true}
                              enableSorting={false}
                              enableFullScreenToggle={false}
                              columns={columns}
                              data={deviceList}
                              paginationDisplayMode="pages"
                              renderDetailPanel={({ row }) => (
                                <Grid container sx={styles1.grid1}>
                                  <Grid size={12} sx={[styles1.grid2, { background: '#454546' }]}>
                                    <Typography
                                      sx={[
                                        styles1.Typography2,
                                        {
                                          marginLeft: 1,
                                          color: '#ffffff',
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        },
                                      ]}
                                    >
                                      상세정보
                                    </Typography>
                                  </Grid>
                                  <Grid size={12}>
                                    <Grid container>
                                      <Grid
                                        size={6}
                                        sx={{
                                          padding: 3,
                                          justifyItems: 'center',
                                        }}
                                      >
                                        <Stack
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'Noto Sans',
                                              fontSize: '18px',
                                              fontWeight: 600,
                                              height: 40,
                                            }}
                                          >
                                            기본정보
                                          </Typography>
                                          <Divider
                                            flexItem
                                            sx={{
                                              marginBottom: 3,
                                              borderRightWidth: 5,
                                              borderBottom: '7px solid',
                                              // border색깔 시작
                                              borderImage:
                                                'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                                              borderImageSlice: 1,
                                              // border색깔 끝
                                            }}
                                          ></Divider>
                                          <Grid container spacing={3}>
                                            <Grid size={6}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비유형</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>{row.original.dsi}</Typography>
                                                </Box>
                                                <Typography sx={styles1.Typography4}>제조사</Typography>
                                                <Box sx={styles1.Box1}>
                                                  {' '}
                                                  <Typography sx={styles1.Typography5}>{row.original.cnm}</Typography>
                                                </Box>
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Stack spacing={1}>
                                                <Typography sx={[styles1.Typography4]}>기능정보</Typography>
                                                {row.original.topic_list.map((item, index) => {
                                                  return (
                                                    <Box key={index} sx={[styles1.Box1, { margin: 1 }]}>
                                                      <Typography sx={styles1.Typography5}>{item}</Typography>
                                                    </Box>
                                                  )
                                                })}

                                                <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>
                                                  블루투스 서비스 리스트
                                                </Typography>
                                                {row.original.b_service_list !== null ? (
                                                  row.original.b_service_list.map((item, index) => {
                                                    return (
                                                      <Box key={index} sx={styles1.Box1}>
                                                        <Typography sx={styles1.Typography5}>{item}</Typography>
                                                      </Box>
                                                    )
                                                  })
                                                ) : (
                                                  <Box sx={styles1.Box1}>null</Box>
                                                )}
                                              </Stack>
                                            </Grid>
                                          </Grid>
                                        </Stack>
                                      </Grid>
                                      <Grid
                                        size={6}
                                        sx={{
                                          padding: 3,
                                          justifyItems: 'center',
                                        }}
                                      >
                                        <Stack
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'Noto Sans',
                                              fontSize: '18px',
                                              fontWeight: 600,
                                              height: 40,
                                            }}
                                          >
                                            장비세부정보
                                          </Typography>
                                          <Divider
                                            flexItem
                                            sx={{
                                              marginBottom: 3,
                                              borderRightWidth: 5,
                                              borderBottom: '7px solid',
                                              // border색깔 시작
                                              borderImage:
                                                'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                                              borderImageSlice: 1,
                                              // border색깔 끝
                                            }}
                                          ></Divider>
                                          <Stack spacing={1}>
                                            <Stack direction="row" spacing={3}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비ID</Typography>
                                                <Box sx={styles1.Box1}>
                                                  {' '}
                                                  <Typography sx={styles1.Typography5}>{row.original.di}</Typography>
                                                </Box>
                                              </Stack>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>관리부서</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>
                                                    {row.original.orglist[row.original.orglist.length - 2]}
                                                  </Typography>
                                                </Box>
                                              </Stack>
                                            </Stack>
                                            <Stack direction="row" spacing={3}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비이름</Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Box sx={styles1.Box1}>
                                                    <Typography sx={styles1.Typography5}>
                                                      {row.original.dname}
                                                    </Typography>
                                                  </Box>
                                                ) : (
                                                  <TextField
                                                    sx={styles1.Select1}
                                                    value={modifyDname}
                                                    onChange={(e) => handleModifyDname(e, row.original)}
                                                  ></TextField>
                                                )}
                                              </Stack>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>등록일자</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>
                                                    {row.original.create_date}
                                                  </Typography>
                                                </Box>
                                              </Stack>
                                            </Stack>

                                            <Typography sx={[styles1.Typography4]}>지정위치</Typography>
                                            {row.original.isFlag === false ||
                                            row.original.hasOwnProperty('isFlag') === false ? (
                                              <Box sx={styles1.Box1}>
                                                <Typography sx={styles1.Typography5}>
                                                  {row.original.orglist.map((item, index) =>
                                                    row.original.orglist.length - 1 === index ? `${item}` : `${item}> `
                                                  )}
                                                </Typography>
                                              </Box>
                                            ) : (
                                              <Select
                                                value={modifyDloc}
                                                onChange={(e) => handleModifyDloc(e, row.original)}
                                                sx={[styles1.Select1, { width: 150 }]}
                                              >
                                                {locationList.map((item, index) => {
                                                  return (
                                                    <MenuItem key={index} value={item.loid}>
                                                      {item.lon}
                                                    </MenuItem>
                                                  )
                                                })}
                                              </Select>
                                            )}
                                          </Stack>
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: 1 }}>
                                    {/* mark */}

                                    {row.original.isFlag === false ||
                                    row.original.hasOwnProperty('isFlag') === false ? (
                                      <Button
                                        sx={{
                                          borderRadius: '6px',
                                          background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                        }}
                                        variant="contained"
                                        onClick={() => modifyFlag(row.original)}
                                      >
                                        정보 수정
                                      </Button>
                                    ) : (
                                      <div>
                                        <Button
                                          sx={{
                                            borderRadius: '6px',
                                            background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                          }}
                                          variant="contained"
                                          onClick={() => modifyFlagSave(row.original)}
                                        >
                                          수정
                                        </Button>{' '}
                                        <Button
                                          sx={{
                                            borderRadius: '6px',
                                            background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                          }}
                                          variant="contained"
                                          onClick={() => modifyFlagCancel(row.original)}
                                        >
                                          취소
                                        </Button>
                                      </div>
                                    )}
                                  </Grid>

                                  <Grid size={12}></Grid>
                                </Grid>
                              )}
                              mantineTableHeadCellProps={{
                                sx: { color: '#ffffff', backgroundColor: '#2F2E41' },
                                align: 'start',
                              }}
                              mantineTableBodyCellProps={{
                                sx: {
                                  color: '#CCCCCC',
                                  background:
                                    'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                                },
                                align: 'start',
                              }}
                              mantineDetailPanelProps={{
                                sx: {
                                  color: '#ffffff',
                                  background:
                                    'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                                },
                              }}
                              mantineTopToolbarProps={{
                                sx: {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  // mantine-Stack-root
                                  '.mantine-Alert-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                  },
                                  '.mantine-Stack-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                  },
                                },
                              }}
                              mantineBottomToolbarProps={{
                                sx: {
                                  background: '#21222D',
                                  '.mantine-Input-input': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                  '.mantine-InputWrapper-label': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                },
                              }}
                              mantinePaginationProps={{
                                sx: {
                                  background: '#21222D',
                                  '.mantine-UnstyledButton-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                },
                              }}
                              // mantineSelectCheckboxProps={{
                              //   align: 'center',
                              //   color: 'violet', //makes all checkboxes use a different color other than the primaryColor
                              // }}
                            />
                          </div>
                        </TabPanel>
                        {/* 네트워크장비 */}
                        <TabPanel value="true">
                          <div style={{ marginTop: -25 }}>
                            <MantineReactTable
                              initialState={{
                                pagination: {
                                  pageIndex: 0,
                                  pageSize: 30,
                                },
                              }}
                              getRowId={(row) => row.di}
                              onRowSelectionChange={setRowSelection}
                              state={{ rowSelection }}
                              selectDisplayMode="checkbox"
                              enableRowSelection={true}
                              enableMultiRowSelection={true}
                              enableColumnActions={false}
                              enableColumnFilters={false}
                              enablePagination={true}
                              enableSorting={false}
                              enableFullScreenToggle={false}
                              columns={columns}
                              data={deviceList}
                              paginationDisplayMode="pages"
                              renderDetailPanel={({ row }) => (
                                <Grid container sx={styles1.grid1}>
                                  <Grid size={12} sx={[styles1.grid2, { background: '#454546' }]}>
                                    <Typography
                                      sx={[
                                        styles1.Typography2,
                                        {
                                          marginLeft: 1,
                                          color: '#ffffff',
                                          fontFamily: 'Noto Sans KR',
                                          fontSize: 17,
                                          fontWeight: 700,
                                          display: 'flex',
                                          justifyContent: 'flex-start',
                                        },
                                      ]}
                                    >
                                      상세정보
                                    </Typography>
                                  </Grid>
                                  <Grid size={12}>
                                    <Grid container>
                                      <Grid
                                        size={6}
                                        sx={{
                                          padding: 3,
                                          justifyItems: 'center',
                                        }}
                                      >
                                        <Stack
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'Noto Sans',
                                              fontSize: '18px',
                                              fontWeight: 600,
                                              height: 40,
                                            }}
                                          >
                                            기본정보
                                          </Typography>
                                          <Divider
                                            flexItem
                                            sx={{
                                              marginBottom: 3,
                                              borderRightWidth: 5,
                                              borderBottom: '7px solid',
                                              // border색깔 시작
                                              borderImage:
                                                'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                                              borderImageSlice: 1,
                                              // border색깔 끝
                                            }}
                                          ></Divider>
                                          <Grid container spacing={3}>
                                            <Grid size={6}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비유형</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>{row.original.dsi}</Typography>
                                                </Box>
                                                <Typography sx={styles1.Typography4}>제조사</Typography>
                                                <Box sx={styles1.Box1}>
                                                  {' '}
                                                  <Typography sx={styles1.Typography5}>{row.original.cnm}</Typography>
                                                </Box>
                                              </Stack>
                                            </Grid>
                                            <Grid size={6}>
                                              <Stack spacing={1}>
                                                <Typography sx={[styles1.Typography4]}>기능정보</Typography>
                                                {row.original.topic_list.map((item, index) => {
                                                  return (
                                                    <Box key={index} sx={[styles1.Box1, { margin: 1 }]}>
                                                      <Typography sx={styles1.Typography5}>{item}</Typography>
                                                    </Box>
                                                  )
                                                })}

                                                <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>
                                                  블루투스 서비스 리스트
                                                </Typography>
                                                {row.original.b_service_list !== null ? (
                                                  row.original.b_service_list.map((item, index) => {
                                                    return (
                                                      <Box key={index} sx={styles1.Box1}>
                                                        <Typography sx={styles1.Typography5}>{item}</Typography>
                                                      </Box>
                                                    )
                                                  })
                                                ) : (
                                                  <Box sx={styles1.Box1}>null</Box>
                                                )}
                                              </Stack>
                                            </Grid>
                                          </Grid>
                                        </Stack>
                                      </Grid>
                                      <Grid
                                        size={6}
                                        sx={{
                                          padding: 3,
                                          justifyItems: 'center',
                                        }}
                                      >
                                        <Stack
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'Noto Sans',
                                              fontSize: '18px',
                                              fontWeight: 600,
                                              height: 40,
                                            }}
                                          >
                                            장비세부정보
                                          </Typography>
                                          <Divider
                                            flexItem
                                            sx={{
                                              marginBottom: 3,
                                              borderRightWidth: 5,
                                              borderBottom: '7px solid',
                                              // border색깔 시작
                                              borderImage:
                                                'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                                              borderImageSlice: 1,
                                              // border색깔 끝
                                            }}
                                          ></Divider>
                                          <Stack spacing={1}>
                                            <Stack direction="row" spacing={3}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비ID</Typography>
                                                <Box sx={styles1.Box1}>
                                                  {' '}
                                                  <Typography sx={styles1.Typography5}>{row.original.di}</Typography>
                                                </Box>
                                              </Stack>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>관리부서</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>
                                                    {row.original.orglist[row.original.orglist.length - 2]}
                                                  </Typography>
                                                </Box>
                                              </Stack>
                                            </Stack>
                                            <Stack direction="row" spacing={3}>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>장비이름</Typography>
                                                {row.original.isFlag === false ||
                                                row.original.hasOwnProperty('isFlag') === false ? (
                                                  <Box sx={styles1.Box1}>
                                                    <Typography sx={styles1.Typography5}>
                                                      {row.original.dname}
                                                    </Typography>
                                                  </Box>
                                                ) : (
                                                  <TextField
                                                    sx={styles1.Select1}
                                                    value={modifyDname}
                                                    onChange={(e) => handleModifyDname(e, row.original)}
                                                  ></TextField>
                                                )}
                                              </Stack>
                                              <Stack spacing={1}>
                                                <Typography sx={styles1.Typography4}>등록일자</Typography>
                                                <Box sx={styles1.Box1}>
                                                  <Typography sx={styles1.Typography5}>
                                                    {row.original.create_date}
                                                  </Typography>
                                                </Box>
                                              </Stack>
                                            </Stack>

                                            <Typography sx={[styles1.Typography4]}>지정위치</Typography>
                                            {row.original.isFlag === false ||
                                            row.original.hasOwnProperty('isFlag') === false ? (
                                              <Box sx={styles1.Box1}>
                                                <Typography sx={styles1.Typography5}>
                                                  {row.original.orglist.map((item, index) =>
                                                    row.original.orglist.length - 1 === index ? `${item}` : `${item}> `
                                                  )}
                                                </Typography>
                                              </Box>
                                            ) : (
                                              <Select
                                                value={modifyDloc}
                                                onChange={(e) => handleModifyDloc(e, row.original)}
                                                sx={[styles1.Select1, { width: 150 }]}
                                              >
                                                {locationList.map((item, index) => {
                                                  return (
                                                    <MenuItem key={index} value={item.loid}>
                                                      {item.lon}
                                                    </MenuItem>
                                                  )
                                                })}
                                              </Select>
                                            )}
                                          </Stack>
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: 1 }}>
                                    {row.original.isFlag === false ||
                                    row.original.hasOwnProperty('isFlag') === false ? (
                                      <Button
                                        sx={{
                                          borderRadius: '6px',
                                          background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                        }}
                                        variant="contained"
                                        onClick={() => modifyFlag(row.original)}
                                      >
                                        정보 수정
                                      </Button>
                                    ) : (
                                      <div>
                                        <Button
                                          sx={{
                                            borderRadius: '6px',
                                            background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                          }}
                                          variant="contained"
                                          onClick={() => modifyFlagSave(row.original)}
                                        >
                                          수정
                                        </Button>{' '}
                                        <Button
                                          sx={{
                                            borderRadius: '6px',
                                            background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                                          }}
                                          variant="contained"
                                          onClick={() => modifyFlagCancel(row.original)}
                                        >
                                          취소
                                        </Button>
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid size={12}></Grid>
                                </Grid>
                              )}
                              mantineTableHeadCellProps={{
                                sx: { color: '#ffffff', backgroundColor: '#2F2E41' },
                                align: 'start',
                              }}
                              mantineTableBodyCellProps={{
                                sx: {
                                  color: '#CCCCCC',
                                  background:
                                    'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                                },
                                align: 'start',
                              }}
                              mantineDetailPanelProps={{
                                sx: {
                                  color: '#ffffff',
                                  background:
                                    'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                                },
                              }}
                              mantineTopToolbarProps={{
                                sx: {
                                  color: '#ffffff',
                                  background: '#21222D',
                                  // mantine-Stack-root
                                  '.mantine-Alert-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                  },
                                  '.mantine-Stack-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                  },
                                },
                              }}
                              mantineBottomToolbarProps={{
                                sx: {
                                  background: '#21222D',
                                  '.mantine-Input-input': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                  '.mantine-InputWrapper-label': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                },
                              }}
                              mantinePaginationProps={{
                                sx: {
                                  background: '#21222D',
                                  '.mantine-UnstyledButton-root': {
                                    color: '#ffffff',
                                    background: '#21222D',
                                    borderColor: '#CCCCCC',
                                  },
                                },
                              }}
                              // mantineSelectCheckboxProps={{
                              //   align: 'center',
                              //   color: 'violet', //makes all checkboxes use a different color other than the primaryColor
                              // }}
                            />
                          </div>
                        </TabPanel>
                      </TabContext>
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="/User/IoTManage/GroupManage">
                <GroupManage data={inputLoid} />
              </TabPanel>
              <TabPanel value="/User/IoTManage/OTA">
                <OTA />
              </TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </Grid>

      <Dialog
        open={openDialog}
        onClose={handleClickClose}
        aria-labelledby="draggable-dialog-title"
        PaperComponent={PaperComponent}
        maxWidth={'1000px'}
      >
        <DialogContent
          sx={{
            background: '#2F2E41',
          }}
        >
          <Grid container>
            <Grid
              size={12}
              sx={[
                {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              <Box
                sx={[
                  styles1.grid2,
                  {
                    marginTop: 3,
                    background: '#454546',
                    width: 430,
                    height: 46,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                ]}
              >
                {' '}
                <Typography
                  sx={[
                    styles1.Typography2,
                    {
                      marginLeft: 1,
                      color: '#ffffff',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    },
                  ]}
                >
                  장비등록
                </Typography>
              </Box>
            </Grid>

            <Grid size={12}>
              <Grid container>
                <Grid size={5.5} sx={{ padding: 3, justifyItems: 'flex-end' }}>
                  <Stack
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    spacing={2}
                  >
                    <Typography
                      sx={{
                        color: '#ffffff',
                        fontFamily: 'Noto Sans',
                        fontSize: '18px',
                        fontWeight: 600,
                      }}
                    >
                      기본정보
                    </Typography>
                    <Divider
                      flexItem
                      sx={{
                        marginBottom: 3,
                        borderRightWidth: 5,
                        borderBottom: '7px solid',
                        // border색깔 시작
                        borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                        borderImageSlice: 1,
                        // border색깔 끝
                      }}
                    ></Divider>
                    <Grid container spacing={3}>
                      <Grid size={6}>
                        <Stack spacing={1}>
                          <Typography sx={styles1.Typography4}>장비유형</Typography>
                          {checkValue ? (
                            <TextField
                              sx={[
                                styles1.Select1,
                                {
                                  height: 40,
                                  borderRadius: '8px',
                                  '& .MuiInputBase-input': {
                                    height: 7,
                                  },
                                },
                              ]}
                              value={newInputType}
                              onChange={handleNewInputType}
                            ></TextField>
                          ) : (
                            <Select
                              value={inputDsi}
                              onChange={(e) => handleDsl(e)}
                              sx={[styles1.Select1, { width: 200, height: 40, borderRadius: '6px' }]}
                            >
                              {dslList.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item}>
                                    {item.dsi}
                                  </MenuItem>
                                )
                              })}
                            </Select>
                          )}
                        </Stack>
                      </Grid>
                      <Grid size={6}>
                        {' '}
                        <Stack spacing={1}>
                          <Typography sx={styles1.Typography4}>제조사</Typography>
                          {checkValue ? (
                            <TextField
                              sx={[
                                styles1.Select1,
                                {
                                  height: 40,
                                  borderRadius: '8px',
                                  '& .MuiInputBase-input': {
                                    height: 7,
                                  },
                                },
                              ]}
                              value={newInputCmn}
                              onChange={handleNewInputCmn}
                            ></TextField>
                          ) : (
                            <Box sx={[styles1.Box1, { height: 39 }]}>
                              <Typography sx={styles1.Typography5}>{regDeviceData.cnm}</Typography>
                            </Box>
                          )}

                          <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>기능정보</Typography>
                          {checkValue ? (
                            <div>
                              {/* {JSON.stringify(moreAdd)} */}
                              {newInputOption && newInputOption.topic_list !== undefined
                                ? newInputOption.topic_list.map((item, index) => {
                                    return (
                                      <Box key={index} sx={styles1.Box1}>
                                        <Typography sx={styles1.Typography5}>{item}</Typography>
                                      </Box>
                                    )
                                  })
                                : ''}
                              {/*  기능추가  */}
                              {/* {moreAdd.map((answer, index) => {
                            return (
                              <div key={index}>
                                <label htmlFor={`${answer}${index + 1}`}>{`추가기능 ${index + 1}:`}</label>
                                <input
                                  type="text"
                                  onChange={(e) => handleMoreAddChange(index, e.target.value)}
                                  value={answer}
                                />
                              </div>
                            )
                          })} */}
                            </div>
                          ) : (
                            <div>
                              {regDeviceData.topic_list === undefined ||
                              regDeviceData.topic_list === null ||
                              regDeviceData.topic_list.length === 0 ? (
                                <Box sx={styles1.Box1}>
                                  <Typography sx={styles1.Typography5}>장비유형을 선택하세요.</Typography>
                                </Box>
                              ) : (
                                ''
                              )}
                              {regDeviceData.topic_list?.map((item) => {
                                return (
                                  <Box sx={styles1.Box1}>
                                    <Typography sx={styles1.Typography5}>{item}</Typography>
                                  </Box>
                                )
                              })}
                            </div>
                          )}

                          <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>블루투스 서비스 리스트</Typography>
                          {checkValue ? (
                            <div>
                              {newInputOption.b_service_list === undefined ||
                              newInputOption.b_service_list === null ||
                              newInputOption.b_service_list.length === 0 ? (
                                <Box sx={styles1.Box1}>
                                  <Typography sx={styles1.Typography5}>사용안함</Typography>
                                </Box>
                              ) : (
                                ''
                              )}
                              {newInputOption.b_service_list?.map((item, index) => {
                                return (
                                  <Box key={index} sx={styles1.Box1}>
                                    <Typography sx={styles1.Typography5}>{item}</Typography>
                                  </Box>
                                )
                              })}
                            </div>
                          ) : (
                            <div>
                              {regDeviceData.b_service_list === undefined ||
                              regDeviceData.b_service_list === null ||
                              regDeviceData.b_service_list.length === 0 ? (
                                <Box sx={styles1.Box1}>
                                  <Typography sx={styles1.Typography5}>사용안함</Typography>
                                </Box>
                              ) : (
                                ''
                              )}
                              {regDeviceData.b_service_list?.map((item, index) => {
                                return (
                                  <Box key={index} sx={styles1.Box1}>
                                    <Typography sx={styles1.Typography5}>{item}</Typography>
                                  </Box>
                                )
                              })}
                            </div>
                          )}
                          {/* mark */}

                          {checkValue ? (
                            <>
                              {newInputOption.ble_rssi === undefined ||
                              newInputOption.ble_rssi === null ||
                              newInputOption.ble_rssi.length === 0 ? (
                                ''
                              ) : (
                                <>
                                  <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>
                                    블루투스 신호 감도
                                  </Typography>
                                  <Box sx={styles1.Box1}>
                                    <Typography sx={styles1.Typography5}>{newInputOption.ble_rssi}</Typography>
                                  </Box>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {regDeviceData.ble_rssi === undefined ||
                              regDeviceData.ble_rssi === null ||
                              regDeviceData.ble_rssi.length === 0 ? (
                                ''
                              ) : (
                                <>
                                  <Typography sx={[styles1.Typography4, { paddingTop: 3 }]}>
                                    블루투스 신호 감도
                                  </Typography>
                                  <Box sx={styles1.Box1}>
                                    <Typography sx={styles1.Typography5}>{regDeviceData.ble_rssi}</Typography>
                                  </Box>
                                </>
                              )}
                            </>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
                <Grid size={1} sx={{ padding: 3, justifyItems: 'center' }}></Grid>
                <Grid size={5.5} sx={{ padding: 3, justifyItems: 'flex-start' }}>
                  <Stack
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    spacing={2}
                  >
                    <Typography
                      sx={{
                        color: '#ffffff',
                        fontFamily: 'Noto Sans',
                        fontSize: '18px',
                        fontWeight: 600,
                      }}
                    >
                      장비세부정보
                    </Typography>
                    <Divider
                      flexItem
                      sx={{
                        marginBottom: 3,
                        borderRightWidth: 5,
                        borderBottom: '7px solid',
                        // border색깔 시작
                        borderImage: 'linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%)',
                        borderImageSlice: 1,
                        // border색깔 끝
                      }}
                    ></Divider>
                    <Stack spacing={1}>
                      <Stack direction="row" spacing={3}>
                        <Stack spacing={1}>
                          <Typography sx={styles1.Typography4}>장비ID</Typography>
                          <TextField
                            sx={[
                              styles1.Select1,
                              {
                                height: 40,
                                borderRadius: '8px',
                                '& .MuiInputBase-input': {
                                  height: 7,
                                },
                              },
                            ]}
                            value={inputDi}
                            onChange={handleInputDi}
                          ></TextField>
                        </Stack>
                        <Stack spacing={1}>
                          <Typography sx={styles1.Typography4}>관리부서</Typography>
                          <Box sx={styles1.Box1}>
                            <Typography sx={styles1.Typography5}>{OrgName}</Typography>
                          </Box>
                        </Stack>
                      </Stack>
                      <Stack direction="row" spacing={3}>
                        <Stack spacing={1}>
                          <Typography sx={styles1.Typography4}>장비이름</Typography>
                          <TextField
                            sx={[
                              styles1.Select1,
                              {
                                height: 40,
                                borderRadius: '8px',
                                '& .MuiInputBase-input': {
                                  height: 7,
                                },
                              },
                            ]}
                            value={inputDname}
                            onChange={handleInputDname}
                          ></TextField>
                        </Stack>
                      </Stack>

                      <Typography sx={[styles1.Typography4]}>지정위치</Typography>
                      <Select
                        value={inputLocation}
                        onChange={handleInputLocation}
                        sx={[styles1.Select1, { width: 223, height: 40, borderRadius: '5px' }]}
                      >
                        {locationList.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.loid}>
                              {item.lon}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Stack direction="row">
                <Checkbox
                  sx={{ color: '#ffffff' }}
                  size="small"
                  onChange={handleCheckChange}
                  checked={checkValue}
                ></Checkbox>
                <Typography sx={styles1.Typography3}>해당 정보를 신규장비 유형으로 등록합니다</Typography>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ background: '#2C2D33',display:'flex',justifyContent:'center',alignItems:'center' }}>
          <Button
            disabled={regFlag}
            sx={{
              marginTop:2,
              marginBottom:2,
              marginRight:3,
              borderRadius: '6px',
              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
            }}
            variant="contained"
            onClick={() => postDevice()}
          >
            장비등록
          </Button>
          <Button
            sx={{
              marginTop:2,
              marginBottom:2,
              borderRadius: '6px',
              background: '#807F88',
            }}
            variant="contained"
            onClick={handleClickClose}
          >
            취소
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
